export const formatFileSize = (size: number) => {
  if (size === 0) {
    return "0 o";
  }

  const units = ["o", "Ko", "Mo", "Go", "To", "Po"];
  const k = 1024;

  const i = Math.floor(Math.log(size) / Math.log(k));
  const value = size / Math.pow(k, i);

  return `${Math.round(value)} ${units[i]!}`;
};
